import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Plus, Check } from "lucide-react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { useRFQ } from "../../context/RFQContext";

export default function FeaturedProducts() {
  const { addToEnquiry, isInEnquiry } = useRFQ();
  const { featured } = useContent();

  return (
    <section className="py-20 lg:py-24 bg-[#0f2236]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <Reveal className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Featured range</p>
            <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
              A premium export-style catalogue
            </h2>
          </Reveal>
          <Reveal>
            <Link to="/products" className="tap-target inline-flex items-center gap-2 text-[#2ED9B8] font-medium hover:gap-3 transition-all">
              View full directory <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((p, i) => {
            const added = isInEnquiry(p.slug);
            return (
              <Reveal key={p.slug} delay={(i % 3) * 80}>
                <div className="group h-full bg-card rounded-2xl border border-white/10 overflow-hidden hover:shadow-[0_24px_50px_-28px_rgba(12,97,82,0.5)] transition-all duration-300">
                  <div className="h-1.5 brand-gradient" />
                  <div className="p-6">
                    <span className="inline-block text-[11px] uppercase tracking-[0.15em] text-[#2ED9B8] bg-[#0f2236] px-2.5 py-1 rounded-full">
                      {p.category}
                    </span>
                    <h3 className="mt-4 font-display text-[22px] text-foreground">{p.name}</h3>
                    <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                      Sourced from pre-qualified partners with full documentation and compliance support.
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                      <Link
                        to={`/products/${p.slug}`}
                        className="tap-target text-sm font-medium text-[#2ED9B8] inline-flex items-center gap-1 hover:gap-2 transition-all"
                      >
                        View details <ArrowUpRight className="h-4 w-4" />
                      </Link>
                      <button
                        onClick={() => addToEnquiry({ slug: p.slug, name: p.name })}
                        disabled={added}
                        className={`ml-auto inline-flex items-center gap-1.5 text-sm rounded-full px-3.5 h-9 border transition-colors ${
                          added
                            ? "bg-[#0f2236] border-white/10 text-[#2ED9B8]"
                            : "border-border text-foreground hover:border-[#2ED9B8] hover:text-[#2ED9B8]"
                        }`}
                      >
                        {added ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                        {added ? "Added" : "Enquire"}
                      </button>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
